class InstagramFeed extends HTMLElement {
    constructor() {
        super();
        this.urlInst = this.dataset.instagram;
        this.url = 'https://instafeed.nfcube.com/feed/v6?limit=24&account=tracesoats.myshopify.com&fu=0&fid=0&hash=ed91c4aef0b037e6b6d8e08551e62cc5&locale=en';
        this.RenderElement();
    }

    async RenderElement () {
        await fetch(this.url, 
        {
            method: "POST",
        }).then( res => res.json()).then((res) => {
            const post = res.data;
            this.createElements(post);
        }) 
    }

    createElements (elements) {
        elements.forEach( (el, i) => {
            const { url: url_img } = el.images.standard_resolution;
            const swiperSlide = document.createElement('div');
            swiperSlide.classList.add('swiper-slide');
            if(i % 2 != 1) {
                swiperSlide.classList.add('even');
            }

            const linkInstagram = document.createElement('a');
            linkInstagram.setAttribute('target','_blank');
            linkInstagram.href = this.urlInst;
            const swiperSlideWrap = document.createElement('div');
            swiperSlideWrap.classList.add('swiper-slide__wrap');
            const imageDiv = document.createElement('div');
            imageDiv.classList.add('image');
            const imageWrap = document.createElement('div');
            imageWrap.classList.add('image__wrap');
            const imgElement = document.createElement('img');
            imgElement.src = url_img;
            imageWrap.appendChild(imgElement);
            imageWrap.appendChild(linkInstagram);
            imageDiv.appendChild(imageWrap);
            swiperSlideWrap.appendChild(imageDiv);
            swiperSlide.appendChild(swiperSlideWrap);

            this.querySelector('.swiper-wrapper').appendChild(swiperSlide);
        });

        const sliderElement = this.querySelector('custom-slider');
        if (sliderElement) {
            sliderElement.update();
        }
    }
}

customElements.define('instagram-feed', InstagramFeed);